import React from 'react'
import { Button, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { getOrderItemsColumns } from 'components/orders/OrderItemsColumns/getOrderItemsColumns'
import { IOrderItem } from 'models/orders'
import { getProductEditPath } from 'routing/utils/getProductEditPath'
import styles from './OrderEdit.module.scss'

interface IOrderItemsTableProps {
  items: IOrderItem[]
  canRemoveProduct: boolean
  isRemoveProductId: string | null
  onRemoveProduct: (itemId: string) => void
}

export const OrderItemsTable: React.FC<IOrderItemsTableProps> = ({
  items,
  canRemoveProduct,
  isRemoveProductId,
  onRemoveProduct
}) => {
  const columns: ColumnsType<IOrderItem> = React.useMemo(() => {
    const baseColumns = getOrderItemsColumns()

    if (canRemoveProduct) {
      baseColumns.push({
        title: 'Убрать товар',
        dataIndex: '',
        width: 170,
        render: (_, { _id }) => (
          <Button
            danger
            htmlType='button'
            size='middle'
            className={styles.cancelButton}
            loading={isRemoveProductId === _id}
            onClick={(event) => {
              // клик по строке открывает карточку товара — кнопка не должна его триггерить
              event.stopPropagation()
              onRemoveProduct(_id)
            }}
          >
            Убрать
          </Button>
        )
      })
    }

    return baseColumns
  }, [canRemoveProduct, isRemoveProductId, onRemoveProduct])

  return (
    <Table
      scroll={{ x: 1100 }}
      columns={columns}
      dataSource={items}
      rowKey={(el) => el._id}
      pagination={false}
      style={{ marginBottom: 25 }}
      // фича из main: клик по товару открывает его карточку в новой вкладке
      onRow={({ product_id }) => ({
        onClick: () => {
          if (product_id?._id) {
            window.open(getProductEditPath(product_id._id), '_blank')
          }
        },
        style: { cursor: product_id?._id ? 'pointer' : 'default' }
      })}
    />
  )
}
